import { PlayerProfile } from "@/multiplayer";
import { create } from "zustand";

export const usePlayerStore = create<{
	players: PlayerProfile[]
	handlePlayerListSnapshot: (snapshot: PlayerProfile[]) => void;
}>((set) => ({
	players: [],
	handlePlayerListSnapshot: (snapshot: PlayerProfile[]) => {
		set({ players: snapshot });
	}
}))
